module.exports = __webpack_public_path__ + "static/img/default_img@2x.cbbed68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wxbind/default_img@2x.png
// module id = SF0L
// module chunks = 1